import { useDebounce } from '@hooks/useDebounce';
import SearchIcon from '@mui/icons-material/Search';
import { InputAdornment, InputBase } from '@mui/material';
import React from 'react';

export const SearchBar = ({
    onChange,
    fullWidth,
    ...props
}: {
    placeholder?: string;
    onChange?: (value: string) => void;
    fullWidth?: boolean;
    endAdornment?: React.ReactNode;
}) => {
    const [searchValue, setSearchValue] = React.useState('');
    const handleChange = event => {
        setSearchValue(event.target.value);
    };

    const debouncedValue = useDebounce(searchValue, 500);

    React.useEffect(() => {
        if (!onChange) return;
        onChange?.(debouncedValue);
    }, [debouncedValue, onChange]);

    return (
        <InputBase
            placeholder={props.placeholder || 'Rechercher'}
            value={searchValue}
            onChange={handleChange}
            fullWidth
            startAdornment={
                <InputAdornment position="start" sx={{
                    marginLeft: '12px',
                    display: 'flex',
                    width: '48px',
                    height: '48px',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <SearchIcon />
                </InputAdornment>
            }
            endAdornment={props.endAdornment}
            sx={{
                width: fullWidth ? '100%' : '270px',
                height: '48px',
                borderRadius: '2rem',
                backgroundColor: theme => theme.palette.field.main,
                color: theme => theme.palette.neutralGray.main,
                fontWeight: 500,
                fontSize: '16px',
                lineHeight: '20px',
                border: 'none'
            }}
        />
    );
};
